"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.StyledSpinnerSpan = exports.StyledSpinnerContainer = exports.StyledSpinner = exports.StyledLoadingLabel = exports.StyledLoadingContainer = exports.StyledLoading = exports.Spinner = void 0;

var _loading = _interopRequireDefault(require("./loading"));

var _loading2 = require("./loading.styles");

exports.StyledLoadingContainer = _loading2.StyledLoadingContainer;
exports.StyledSpinnerContainer = _loading2.StyledSpinnerContainer;
exports.StyledSpinner = _loading2.StyledSpinner;
exports.StyledSpinnerSpan = _loading2.StyledSpinnerSpan;
exports.StyledLoading = _loading2.StyledLoading;
exports.StyledLoadingLabel = _loading2.StyledLoadingLabel;

var _spinner = _interopRequireDefault(require("./spinner"));

exports.Spinner = _spinner.default;
// export styled components
var _default = _loading.default;
exports.default = _default;